import { ContentWrapper, type ContentWrapperProps } from "@src/components/ContentWrapper";
import { type FC, type PropsWithChildren, type ReactNode } from "react";

interface ReadOnlyDetailsProps {
    link?: ReactNode;
    title: string;
}

const ReadOnlyDetails: FC<PropsWithChildren<ReadOnlyDetailsProps & ContentWrapperProps>> = ({ children, title, link, ...props }) => (
    <ContentWrapper title={title} link={link}>
        {children}
    </ContentWrapper>
);

export default ReadOnlyDetails;
